/**
 * ANY ANALYTICS EVENTS NOT PREFIXED BY confluence.spa WILL NEED TO BE BACKEND WHITELISTED.
 * The only reason any event is NOT prefixed by confluence.spa is if it is a legacy event.
 * Any new scopes should start with "confluence.spa."
 */
export const ANALYTICS_SCOPE = {
	EDITOR: 'confluence.spa.editor',
};
